import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { MessageService } from '../../services/message.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-index-servicios',
  templateUrl: './index-servicios.component.html',
  styleUrls: ['./index-servicios.component.css']
})
export class IndexServiciosComponent implements OnInit {
  url: string = 'categories';
  public data : Array<any>=[];
  loading: boolean = true;

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.loading = true;
    
    
    this.dataService.getData(this.url).subscribe({
      next: (response: any) => {
        console.log('Respuesta completa:', response);
        if (response && response.data && Array.isArray(response.data)) {
          this.data = response.data;
          console.log('data', this.data);
        } else {
          this.messageService.add('Error al cargar los datos', 'danger');
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener datos:', error);
        this.messageService.add('Error al cargar los datos', 'danger');
        this.loading = false;
      }
    });
  }

  addNew(): void {
    this.router.navigate(['/administracion/services/create']);
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService.deleteData(`${this.url}/delete/${id}`).subscribe({
      next: (response: any) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'danger');
        }
      },
      error: (error) => {
        console.error('Error al eliminar:', error);
        this.messageService.add('Error al eliminar el registro', 'danger');
      }
    });
  }
}
